import { AsyncActionCreator } from '../types';
import { createAsyncAction } from '../utils';
import { AnalyticsActionTypes, GetKeyIndicatorsData } from './analyticsTypes';

export const getKeyIndicatorsData: AsyncActionCreator<
  GetKeyIndicatorsData,
  (payload: GetKeyIndicatorsData['request']['payload']) => {
    payload: GetKeyIndicatorsData['request']['payload'];
  }
> = createAsyncAction<GetKeyIndicatorsData>({
  request: AnalyticsActionTypes.REQUEST_GET_KEY_INDICATORS_DATA,
})((payload: GetKeyIndicatorsData['request']['payload']) => ({
  payload,
}));
